import { Container } from "react-bootstrap";
import classes from "./Description.module.scss";
import { useTranslation } from "next-i18next";

export const financeHash = "finance";

export function Finance() {
  const { t } = useTranslation("case-studies");
  return (
    <Container id={financeHash} className={classes.mainContainer}>
      <h2 className={classes.title}>{t("finance.main_title")}</h2>
    </Container>
  );
}
